import React, { useState } from 'react'
import VolumeDown from '@mui/icons-material/VolumeDown'
import VolumeUp from '@mui/icons-material/VolumeUp'
import { IconButton, Stack, Slider } from '@mui/material'
import { ButtonsWrapper, VolumeMenu } from '../../StyledComponents'
import { topIconsList } from '../../data'

function TopIcons() {
	const [anchorEl, setAnchorEl] = useState(null)
	const [volume, setVolume] = React.useState(30)
	const open = Boolean(anchorEl)
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}
	const handleChange = (event, newValue) => {
		setVolume(newValue)
	}

	return (
		<ButtonsWrapper>
			{topIconsList?.map(({ icon, text, url }) => text === 'Volume' ? (
				<IconButton
					key={text}
					id="volume-button"
					aria-haspopup="true"
					aria-controls={open ? 'volume-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					onClick={handleClick}
				>
					<img src={icon} alt={text} />
				</IconButton>
			) : (
				<IconButton href={url} key={text} target='_blank'>
					<img src={icon} alt={text} />
				</IconButton>
			))}

			<VolumeMenu
				id="volume-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'volume-button',
				}}
			>
				<Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
					<VolumeDown />
					<Slider aria-label="Volume" value={volume} onChange={handleChange} />
					<VolumeUp />
				</Stack>
			</VolumeMenu>
		</ButtonsWrapper>
	)
}

export default TopIcons
